import { ReactElement, useEffect, useState } from "react";
import Button from "../../ui/button";
import InputNumber from "../../ui/input/input-number";
import { Input } from "../../ui/input";

import clsx from "clsx";
import style from "./styles.module.scss";

import { AUTH_CODE_RESEND_TIMEOUT } from "../../../lib/constants";

export interface IConfirmNumberPhoneData {
  numberPhone: string;
  otp: string;
}

interface IConfirmNumberPhone {
  onChange: (key: keyof IConfirmNumberPhoneData, data: string) => void;
  data: IConfirmNumberPhoneData;
  onActions: () => void;
  children?: ReactElement;
  title: string;
  otp: string | undefined;
}

const ConfirmNumberPhone = ({
  data,
  onChange,
  onActions,
  children,
  title,
  otp,
}: IConfirmNumberPhone) => {
  const [isConfirm, setIsConfirm] = useState(false);
  const [time, setTime] = useState(AUTH_CODE_RESEND_TIMEOUT);
  const [timerActive, setTimerActive] = useState(false);

  const validateNumberPhone = () => {
    const regPhone = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/;
    if (data.numberPhone && regPhone.test(data.numberPhone)) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (timerActive) {
      const timerID = setInterval(() => {
        if (time) {
          setTime((prev) => {
            if (prev === 0) {
              clearInterval(timerID);
              setTime(AUTH_CODE_RESEND_TIMEOUT);
              setTimerActive(false);
              return prev;
            }
            return prev - 1;
          });
        }
      }, 1000);

      return () => clearInterval(timerID);
    }
  }, [timerActive]);

  const onClickConfirmPhone = async () => {
    try {
      if (data.numberPhone) {
        setIsConfirm(true);
        await onActions();
        setTimerActive(true);
      }
    } catch (error) {}
  };

  return (
    <div className={style.confirmNumberPhone}>
      <div className={style.confirmNumberPhone__container}>
        <div className={style.confirmNumberPhone__title}>
          <h3>{title}</h3>
        </div>
        <div className={style.confirmNumberPhone__phone}>
          <Input
            name={"confirm-number-phone"}
            autoFocus
            label="Номер телефона"
            type="tel"
            onChange={(value) => onChange("numberPhone", value)}
            placeholder="Например: 89500561452"
            value={data.numberPhone}
            isMainPlaceholder
          />
          <div
            className={clsx(
              style.confirmNumberPhone__phoneConfirm,
              !validateNumberPhone() &&
                style.confirmNumberPhone__phoneConfirm_hide
            )}
          >
            <Button
              onClick={onClickConfirmPhone}
              label={
                time === AUTH_CODE_RESEND_TIMEOUT ? "подтвердить" : `${time} c`
              }
              style={{ height: "38px", fontSize: 15, paddingBottom: "30px" }}
              disabled={time !== AUTH_CODE_RESEND_TIMEOUT}
            />
          </div>
        </div>
        {isConfirm && (
          <div className={style.confirmNumberPhone__opt}>
            <InputNumber
              mode="otp"
              label="Код подтверждения"
              onChange={(value) => onChange("otp", value)}
              length={6}
              placeholder="Например: 123456"
              value={data.otp || otp}
              isMainPlaceholder
            />
          </div>
        )}
        {children && <div>{children}</div>}
      </div>
    </div>
  );
};

export default ConfirmNumberPhone;
